import { render } from "./bar_chart.svg?vue&type=template&id=ee549f48"
const script = {}
script.render = render

export default script